import * as types from './_actionTypes';
import {createToolkitTheme} from "@/uptk/core/packages/theme";

export function saveThemeSuccess(theme: any) {
  
  return {type: types.SAVE_THEME_SUCCESS, theme: theme}
}

export function saveSelectedThemeSuccess(selectedTheme: any) {

  return {type: types.SAVE_SELECTED_THEME_SUCCESS, selectedTheme: selectedTheme}
}

export function saveTheme(theme: any) {

  return function (dispatch: any, getState: any) {
    dispatch(saveThemeSuccess(theme))

  };
}
export function saveSelectedTheme(selectedTheme: any) {

  return function (dispatch: any, getState: any) {
    dispatch(saveSelectedThemeSuccess(selectedTheme))
  };
}
